const AppConfig = {
  api: {
    version: 'v1',
    url: 'https://sweetaudiosuite.com',
  },
};

export default AppConfig;
